<template>
  <div class="data_crd" :class="{ allowClick: podCastCard || seriesCard }">
    <div class="data_crd_img" :class="{ data_crd_real_img: dataObj.cover || dataObj.image }">
      <img v-if="dataObj.cover || dataObj.image"
        :src="dataObj.cover ? $store.state.ASSETS_BASE_URL + 'assets/uploaded/' + dataObj.cover : dataObj.image"
        alt="Cover Image" @click="$emit('dataClick')">
      <b-skeleton v-else @click="$emit('dataClick')" id="img-skeleton"></b-skeleton>
      <div class="data_crd_img_actions">
        <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
          <template #trigger>
            <b-icon icon="dots-vertical" type="is-white"></b-icon>
          </template>
          <b-dropdown-item @click="$emit('deleteMedia', dataObj)" aria-role="listitem">
            Delete</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <h1 class="data_crd_name" @click="$emit('dataClick')">{{ dataObj.title ? dataObj.title : '--' }}</h1>
    <p class="data_crd_subname">{{ dataObj.subtitle }}</p>
    <div class="data_crd_sub_data" v-if="seriesCard">
      <div class="sub_serie">
        <p>SS {{ dataObj.seasons }}</p>
        <p>EP {{ dataObj.episodes }}</p>
      </div>
      <div class="data_crd_sub_data_other">
        <span class="icon">TV</span>
        <button @click="$emit('edit', dataObj)">Edit</button>
      </div>
    </div>
    <div class="data_crd_sub_data" v-else-if="podCastCard">
      <p>{{ dataObj.episodesCount }} Episodes</p>
      <div class="data_crd_sub_data_other">
        <button @click="$emit('edit', dataObj)">Edit</button>
      </div>
    </div>
    <div class="data_crd_sub_data" v-else>
      <p>{{ dataObj.year ? dataObj.year : dataObj.release_year }}</p>
      <div class="data_crd_sub_data_other">
        <span>{{ dataObj.videoTime ? toHHMMSS(dataObj.videoTime) : '--' }}</span>
        <button @click="$emit('edit', dataObj)">Edit</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataObj: {
      type: Object,
      default: null
    },
    seriesCard: {
      type: Boolean,
      default: null
    },
    podCastCard: {
      type: Boolean,
      default: null
    }
  },
}
</script>

<style lang="scss" scoped>
.data_crd {
  height: fit-content;
  width: 100%;

  &:hover {
    .data_crd_img {
      img {
        transform: scale(1.1);
      }
    }
  }

  &.allowClick {
    .data_crd_img {
      cursor: pointer;
    }

    &:hover {
      h1.data_crd_name {
        color: var(--wecodefy-secondary-color, #9fc953);
        cursor: pointer;
      }
    }
  }

  .data_crd_img {
    height: 300px;
    margin-bottom: 10px;
    border-radius: 5px;
    overflow: hidden;
    position: relative;

    // z-index: 1;
    &.data_crd_real_img {
      &::before {
        position: absolute;
        content: '';
        height: 25%;
        width: 100%;
        top: 0;
        left: 0;
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.304), transparent);
        z-index: 1;
        pointer-events: none;
      }
    }

    @media (max-width: 600px) {
      height: 250px;
    }

    .data_crd_img_actions {
      position: absolute;
      top: 10px;
      right: 8px;
      cursor: pointer;
      z-index: 2;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: .5s;
      transform: scale(1);
    }

    .b-skeleton {
      height: 100%;

      .b-skeleton-item {
        height: 100%;
      }
    }
  }

  h1.data_crd_name {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 1px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    transition: .5s;
  }

  p.data_crd_subname {
    opacity: .7;
  }

  .data_crd_sub_data {
    margin-top: 7px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .sub_serie {
      display: flex;
      column-gap: 10px;
    }

    p {
      color: #5F5F5F;
    }

    .data_crd_sub_data_other {
      display: flex;
      column-gap: 5px;
      align-items: center;
      color: #5F5F5F;

      button {
        border: 1px solid rgba(95, 95, 95, 0.366);
        padding: 2px 15px;
        background: transparent;
        border-radius: 2px;
        cursor: pointer;
        outline: none;
        color: #5F5F5F;
        transition: .5s;
        margin-left: 5px;

        &:hover {
          background: var(--wecodefy-secondary-color, #9fc953);
          color: white;
          border: 1px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }
  }
}
</style>